import './v2/common'
import './v2/landing.en'
import { initOfferSteps } from './v2/anims'

// первый экран — лёгкая HTML-анимация внутри landing (Lottie не нужен)
initOfferSteps()
